import { Container } from "@mui/material";
import TypingImage from "/typing.png";
import WalletImage from "/wallet.png";
import PrinterImage from "/printer.jpeg";
import { motion } from "framer-motion";

export const HowItWorks: React.FC = () => {
  return (
    <><div className="bg-white text-black py-20 bg-pattern bg-cover bg-center bg-no-repeat">
      <Container>
        <motion.h2 className="text-center md:mt-12 font-semibold text-5xl md:text-7xl" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut" }} viewport={{ once: true }}>
          How It Works
        </motion.h2>
        <motion.div className="flex flex-col gap-14 mt-14" initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: "easeOut", staggerChildren: 0.2 }} viewport={{ once: true }}>
          {[
            {
              step: "1",
              title: "Create Your Profile",
              desc: "Enter your emergency contacts and medical information in just a few minutes",
              img: TypingImage,
            },
            {
              step: "2",
              title: "Get Your QR Code",
              desc: "We generate and print a unique QR code onto a compact, wallet-sized card",
              img: PrinterImage,
            },
            {
              step: "3",
              title: "Stay Protected",
              desc: "Keep your Diamedic card with you for instant access anytime, anywhere",
              img: WalletImage,
            },
          ].map((item, idx) => (
            <motion.div
              key={idx}
              className="flex bg-white md:flex-row flex-col-reverse items-center gap-8 shadow-md border-x-0 border-[1px] rounded-3xl p-4 md:p-16"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="grid md:grid-cols-5 grid-cols-1 gap-2">
                <div className="md:order-1 order-none">
                  <img alt={item.title} src={item.img} loading="lazy" />
                </div>
                <div className="flex flex-col gap-2 md:col-span-4">
                  <div>
                    <p className="text-5xl font-bold text-yellow-500">{item.step}.</p>
                  </div>
                  <div>
                    <p className="md:text-4xl text-2xl mb-3 font-bold">{item.title}</p>
                    <p className="md:text-xl text-xl text-gray-700">{item.desc}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </Container>

    </div><div
      className="absolute w-full overflow-hidden pointer-events-none"
      style={{ zIndex: 0 }} // Ensure it's behind everything
    >
        <img
          src="/intersecting-waves-split-white.svg"
          alt="Wave"
        />
      </div></>
  );
};